// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleView_root__vDBhh","invisible":"ToggleView_invisible__1v0ke"};